import React from "react";
import PropTypes from "prop-types";
import { customStyles } from "../../helpers";
import HelperText from "../../../../../../components/atoms/HelperText";
import Select from "../../../../../../components/Select";
import GeneWithRefGenomeLink from "../../../../../../common/helpers/GeneWithRefGenomeLink";

/*
        If transcript_candidates array is empty hide the select dropdown menu and display
        message "This variant is outside all coding transcripts", otherwise display the dropdown
        menu.
*/

const TranscriptsDropdown = ({
  transcriptsOptions,
  refGenome,
  acmgSelected,
  transcript,
  onChange,
  varsomeHost,
}) => {
  if (transcriptsOptions && transcriptsOptions.length > 0) {
    return (
      <div className="tw-flex tw-justify-center tw-items-center">
        <Select
          className="lg:w-full"
          isSearchable={false}
          value={transcriptsOptions.filter(
            (option) => option.value === transcript
          )}
          options={transcriptsOptions}
          onChange={(e) => onChange(e)}
          styles={customStyles}
          placeholder="Select a transcript to annotate"
        />
        <HelperText
          RenderContent={() => {
            return (
              <React.Fragment>
                <div>
                  ACMG annotation used: &nbsp;
                  <a
                    href={`${varsomeHost}/transcript/${refGenome}/${acmgSelected.name}`}
                    target="_blank"
                  >
                    {acmgSelected.name}
                  </a>
                  {`${
                    acmgSelected.canonical ? " canonical," : ""
                  } protein length ${(
                    acmgSelected.plength / 3
                  ).toFixed()} , for gene `}
                  <GeneWithRefGenomeLink
                    href={`${varsomeHost}/gene/${acmgSelected.gene}`}
                    target="_blank"
                  >
                    {acmgSelected.gene}
                  </GeneWithRefGenomeLink>
                </div>
                <div>reason: {acmgSelected.reason}</div>
                <div>
                  {acmgSelected.impact !== "non-coding"
                    ? `coding impact: variant is ${acmgSelected.impact} in this transcript`
                    : ""}
                </div>
              </React.Fragment>
            );
          }}
        />
      </div>
    );
  }
  return <>Variant is non-coding in all transcripts.</>;
};

TranscriptsDropdown.propTypes = {
  transcriptsOptions: PropTypes.arrayOf(PropTypes.shape({})),
  refGenome: PropTypes.string.isRequired,
  acmgSelected: PropTypes.shape({
    canonical: PropTypes.bool,
    gene: PropTypes.string,
    impact: PropTypes.string,
    name: PropTypes.string,
    plength: PropTypes.number,
    reason: PropTypes.string,
  }),
  transcript: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  varsomeHost: PropTypes.string.isRequired,
};

TranscriptsDropdown.defaultProps = {
  acmgSelected: {},
  transcriptsOptions: [],
  transcript: "",
};

export default React.memo(TranscriptsDropdown);
